module.exports = __webpack_public_path__ + "img/yangru.d00d1214.jpg";